/** Display name of an access row: employee first, then user, then email. */
export function accessDisplayName(access) {
  if (!access) return "";
  const person = access.employee || access.user || {};
  const fullName = [person.first_name, person.last_name]
    .filter(Boolean)
    .join(" ")
    .trim();
  return fullName || person.name || person.email || "";
}

function readCurrentAccess() {
  try {
    const raw =
      typeof localStorage === "undefined"
        ? null
        : localStorage.getItem("accessPermission");
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

/**
 * Who corrected a version, as shown in the Corrected badge tooltip.
 *
 * The API exposes `corrected_by` as an Access id only, so:
 * - `corrected_by_name` wins when the payload carries it;
 * - otherwise the current user's name when `corrected_by` is their access id;
 * - otherwise "" (the badge falls back to "another user").
 */
export function resolveCorrectedByName({
  correctedByName = "",
  correctedBy = null,
} = {}) {
  if (correctedByName) return correctedByName;
  if (correctedBy == null) return "";
  const access = readCurrentAccess();
  if (access?.id == null || String(access.id) !== String(correctedBy)) return "";
  return accessDisplayName(access);
}
